import sample from 'lodash/sample';
let previousRandomSuggestionTranslationKey, randomSuggestionTranslationKey;
export function getRandomSuggestionKey(suggestions) {
    randomSuggestionTranslationKey = sample(suggestions);
    // reshuffle if needed
    if (previousRandomSuggestionTranslationKey === randomSuggestionTranslationKey) {
        while(randomSuggestionTranslationKey === previousRandomSuggestionTranslationKey){
            randomSuggestionTranslationKey = sample(suggestions);
        }
    }
    previousRandomSuggestionTranslationKey = randomSuggestionTranslationKey;
    // return with a space after the end of the new phrase
    return randomSuggestionTranslationKey;
}

//# sourceMappingURL=utils.js.map